import React from 'react';
import UploadsQueue from '../../components/Admin/AdminEditor/UploadsQueue/UploadsQueue';

export default function () {
	return <UploadsQueue />;
}
